export const validateRequireDigits = (value: string): boolean => {
  return /\d/.test(value);
};
